import { ApiHelper } from './helper/ApiHelper';

const apiHelper = new ApiHelper();

export class CommonService {
    constructor() {
    }

    getCountriesList() {
        const uri = `/countries/names`;
        return apiHelper.get(uri);
    }

    getFinancialYears(companyCode, categoryCode) {
        const uri = `/api/dashboard/get-financial-year?company-code=${companyCode}&category-code=${categoryCode}`
        return apiHelper.get(uri);

    }

}